// import React, { useEffect, useState } from "react";
// import api from "../../../../../api/axios";
// import Swal from "sweetalert2";

// const EditRoom = ({ roomTypes = [], amenities = [], fetchRooms }) => {
//   const [loading, setLoading] = useState(false);
//   const [roomId, setRoomId] = useState(null);

//   const [formData, setFormData] = useState({
//     room_number: "",
//     room_type_id: "",
//     capacity: "",
//     extra_beds: "",
//     extra_bed_charge: "",
//     room_price: "",
//     room_size: "",
//     bed_type: "",
//     bed_number: "",
//     description: "",
//     condition: "",
//     status: "",
//     is_active: true,
//     amenities: [],
//   });

//   useEffect(() => {
//     const handler = (e) => {
//       console.log(e);
//       loadRoom(e.detail);
//     };
//     window.addEventListener("open-edit-room", handler);
//     return () => window.removeEventListener("open-edit-room", handler);
//   }, []);

//   const loadRoom = async (id) => {
//     setLoading(true);
//     setRoomId(id);

//     try {
//       const res = await api.get(`/pms/rooms/${id}`);
//       const room = res.data.data;

//       // Convert type name → ID
//       const typeObj = roomTypes.find((t) => t.name === room.type);

//       setFormData({
//         room_number: room.room_number || "",
//         room_type_id: typeObj ? typeObj.id : "",
//         capacity: room.capacity || "",
//         extra_beds: room.extra_beds || "",
//         extra_bed_charge: room.extra_bed_charge || "",
//         room_price: room.room_price || "",
//         room_size: room.room_size || "",
//         bed_type: room.bed_type || "",
//         bed_number: room.bed_number || "",
//         description: room.description || "",
//         condition: room.condition || "",
//         status: room.status || "",
//         is_active: room.is_active,
//         amenities: room.amenities || [], // ["Tv","Wifi"]
//       });
//     } catch (err) {
//       Swal.fire("Error", "Unable to load room details!", "error");
//       console.log(err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const toggleAmenity = (name) => {
//     setFormData((prev) => {
//       const exists = prev.amenities.includes(name);
//       return {
//         ...prev,
//         amenities: exists
//           ? prev.amenities.filter((a) => a !== name)
//           : [...prev.amenities, name],
//       };
//     });
//   };

//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: type === "checkbox" ? checked : value,
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     try {
//       await api.put(`/pms/rooms/${roomId}`, formData);

//       Swal.fire("Success", "Room updated successfully", "success");

//       fetchRooms();

//       // Close offcanvas
//       document.getElementById("close-edit")?.click();
//     } catch (err) {
//       Swal.fire("Error", "Failed to update room", "error");
//     }
//   };

//   return (
//     <div className="offcanvas offcanvas-end" id="edit-room">
//       <button
//         id="close-edit"
//         className="d-none"
//         data-bs-dismiss="offcanvas"
//       ></button>

//       <div className="offcanvas-header">
//         <h5>Edit Room</h5>
//         <button className="btn-close" data-bs-dismiss="offcanvas"></button>
//       </div>

//       <div className="offcanvas-body">
//         {loading ? (
//           <p>Loading...</p>
//         ) : (
//           <form onSubmit={handleSubmit}>
//             {/* ROOM NUMBER */}
//             <div className="mb-3">
//               <label>Room Number</label>
//               <input
//                 className="form-control"
//                 name="room_number"
//                 value={formData.room_number}
//                 onChange={handleChange}
//               />
//             </div>

//             {/* ROOM TYPE (send ID, display NAMES) */}
//             <div className="mb-3">
//               <label>Room Type</label>
//               <select
//                 className="form-select"
//                 name="room_type_id"
//                 value={formData.room_type_id}
//                 onChange={handleChange}
//               >
//                 <option value="">Select Room Type</option>

//                 {roomTypes.map((t) => (
//                   <option key={t.id} value={t.id}>
//                     {t.name}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             {/* PRICE + CAPACITY */}
//             <div className="row">
//               <div className="col-6 mb-3">
//                 <label>Room Price</label>
//                 <input
//                   type="number"
//                   className="form-control"
//                   name="room_price"
//                   value={formData.room_price}
//                   onChange={handleChange}
//                 />
//               </div>

//               <div className="col-6 mb-3">
//                 <label>Capacity</label>
//                 <input
//                   type="number"
//                   className="form-control"
//                   name="capacity"
//                   value={formData.capacity}
//                   onChange={handleChange}
//                 />
//               </div>
//             </div>

//             {/* EXTRA BEDS */}
//             <div className="row">
//               <div className="col-6 mb-3">
//                 <label>Extra Beds</label>
//                 <input
//                   type="number"
//                   name="extra_beds"
//                   className="form-control"
//                   value={formData.extra_beds}
//                   onChange={handleChange}
//                 />
//               </div>

//               <div className="col-6 mb-3">
//                 <label>Extra Bed Charge</label>
//                 <input
//                   type="number"
//                   name="extra_bed_charge"
//                   className="form-control"
//                   value={formData.extra_bed_charge}
//                   onChange={handleChange}
//                 />
//               </div>
//             </div>

//             {/* ROOM SIZE */}
//             <div className="mb-3">
//               <label>Room Size</label>
//               <select
//                 className="form-select"
//                 name="room_size"
//                 value={formData.room_size}
//                 onChange={handleChange}
//               >
//                 <option value="">Select Size</option>
//                 <option value="single">Single</option>
//                 <option value="Double">Double</option>
//                 <option value="Triple">Triple</option>
//                 <option value="Quad">Quad</option>
//                 <option value="Queen">Queen</option>
//                 <option value="King">King</option>
//                 <option value="Others">Others</option>
//               </select>
//             </div>

//             {/* BED TYPE */}
//             <div className="mb-3">
//               <label>Bed Type</label>
//               <select
//                 className="form-select"
//                 name="bed_type"
//                 value={formData.bed_type}
//                 onChange={handleChange}
//               >
//                 <option value="">Select Bed Type</option>
//                 <option value="kingbed">King Bed</option>
//                 <option value="queenbed">Queen Bed</option>
//                 <option value="electricbed">Electric Bed</option>
//                 <option value="futonbed">Futon Bed</option>
//                 <option value="mattressbed">Mattress Bed</option>
//                 <option value="airbed">Air Bed</option>
//               </select>
//             </div>

//             {/* CONDITION */}
//             <div className="mb-3">
//               <label>Reserve Condition</label>
//               <input
//                 name="condition"
//                 className="form-control"
//                 value={formData.condition || ""}
//                 onChange={handleChange}
//               />
//             </div>

//             {/* DESCRIPTION */}
//             <div className="mb-3">
//               <label>Description</label>
//               <textarea
//                 className="form-control"
//                 name="description"
//                 value={formData.description || ""}
//                 onChange={handleChange}
//               ></textarea>
//             </div>

//             {/* AMENITIES */}
//             <div className="mb-3">
//               <label>Amenities</label>
//               <div className="row">
//                 {amenities.map((a) => (
//                   <div key={a.id} className="col-6 mb-2">
//                     <div className="form-check">
//                       <input
//                         type="checkbox"
//                         className="form-check-input"
//                         checked={formData.amenities.includes(a.name)}
//                         onChange={() => toggleAmenity(a.name)}
//                       />
//                       <label className="form-check-label">{a.name}</label>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             </div>

//             <button className="btn btn-dark w-100">Save Changes</button>
//           </form>
//         )}
//       </div>
//     </div>
//   );
// };

// export default EditRoom;

// Components/EditRoom.jsx
import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import api from "../../../../../api/axios";

const ROOM_SIZES = [
  "single",
  "double",
  "triple",
  "king",
  "queen",
  "quad",
  "others",
];
const BED_TYPES = [
  "king_bed",
  "queen_bed",
  "electric_bed",
  "futon_bed",
  "mattress_bed",
  "air_bed",
];
const ROOM_STATUS = ["Vacant", "Reserved", "Occupied"];
const HOUSEKEEPING = ["clean", "dirty", "inspected", "out_of_service"];

const EditRoom = ({ open, onClose, room, onUpdated }) => {
  const [form, setForm] = useState({
    room_type_id: "",
    room_number: "",
    capacity: "",
    extra_capability: "",
    bed_charge: "",
    room_size: "single",
    bed_number: "",
    bed_type: "king_bed",
    room_description: "",
    reserve_condition: "",
    is_active: true,
    status: "Vacant",
    housekeeping_status: "dirty",
    is_maintenance: false,
    amenity_ids: [],
  });

  const [roomTypes, setRoomTypes] = useState([]);
  const [amenities, setAmenities] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open) {
      (async () => {
        try {
          const [rtRes, amRes] = await Promise.all([
            api.get("/pms/room-types"),
            api.get("/pms/amenities"),
          ]);
          setRoomTypes(rtRes.data || rtRes.data || []);
          setAmenities(amRes.data || amRes.data || []);
        } catch (err) {
          console.error("Failed to load room types/amenities:", err);
        }
      })();
    }
  }, [open]);

  useEffect(() => {
    if (room && open) {
      setForm({
        room_type_id: room.room_type_id,
        room_number: room.room_number,
        capacity: room.capacity,
        extra_capability: room.extra_capability,
        bed_charge: room.bed_charge,
        room_size: room.room_size || "single",
        bed_number: room.bed_number,
        bed_type: room.bed_type || "king_bed",
        room_description: room.room_description || "",
        reserve_condition: room.reserve_condition || "",
        is_active: room.is_active ?? true,
        status: room.status || "Vacant",
        housekeeping_status: room.housekeeping_status || "dirty",
        is_maintenance: room.is_maintenance ?? false,
        amenity_ids: (room.amenities || []).map((a) => a.id),
      });
    }
  }, [room, open]);

  const toggleAmenity = (id) => {
    setForm((prev) => {
      const exists = prev.amenity_ids.includes(id);
      return {
        ...prev,
        amenity_ids: exists
          ? prev.amenity_ids.filter((x) => x !== id)
          : [...prev.amenity_ids, id],
      };
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.room_type_id) {
      Swal.fire({ icon: "warning", title: "Select room type" });
      return;
    }
    if (!form.room_number?.trim()) {
      Swal.fire({ icon: "warning", title: "Room number required" });
      return;
    }

    try {
      setLoading(true);
      const payload = {
        room_type_id: form.room_type_id,
        room_number: form.room_number,
        capacity: form.capacity,
        extra_capability: form.extra_capability,
        bed_charge: form.bed_charge,
        room_size: form.room_size,
        bed_number: form.bed_number,
        bed_type: form.bed_type,
        room_description: form.room_description,
        reserve_condition: form.reserve_condition,
        is_active: form.is_active,
        status: form.status,
        housekeeping_status: form.housekeeping_status,
        is_maintenance: form.is_maintenance,
        amenities: form.amenity_ids,
      };

      await api.put(`/pms/rooms/${room.id}`, payload);

      Swal.fire({
        icon: "success",
        title: "Room updated",
        timer: 1200,
        showConfirmButton: false,
      });
      if (onUpdated) await onUpdated();
      onClose();
    } catch (err) {
      console.error("Update room error:", err);
      Swal.fire({
        icon: "error",
        title: "Failed to update",
        text: err.response?.data?.message || "Something went wrong",
      });
    } finally {
      setLoading(false);
    }
  };

  if (!open) return null;

  return (
    <>
      <div className="modal-backdrop fade show" />
      <div className="modal d-block" tabIndex={-1}>
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5>Edit Room</h5>
              <button
                className="btn-close"
                onClick={() => {
                  if (onUpdated) onUpdated();
                  onClose();
                }}
              />
            </div>

            <form onSubmit={handleSubmit}>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-6 mb-2">
                    <label className="form-label">Room Type</label>
                    <select
                      className="form-select"
                      value={form.room_type_id}
                      onChange={(e) =>
                        setForm({ ...form, room_type_id: e.target.value })
                      }
                      required
                    >
                      <option value="">Select Room Type</option>
                      {roomTypes.map((rt) => (
                        <option key={rt.id} value={rt.id}>
                          {rt.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-md-6 mb-2">
                    <label className="form-label">Room Number</label>
                    <input
                      className="form-control"
                      value={form.room_number}
                      onChange={(e) =>
                        setForm({ ...form, room_number: e.target.value })
                      }
                      required
                    />
                  </div>

                  <div className="col-md-4 mb-2">
                    <label className="form-label">Capacity</label>
                    <input
                      type="number"
                      className="form-control"
                      value={form.capacity}
                      onChange={(e) =>
                        setForm({ ...form, capacity: e.target.value })
                      }
                    />
                  </div>

                  <div className="col-md-4 mb-2">
                    <label className="form-label">Extra Capability</label>
                    <input
                      className="form-control"
                      value={form.extra_capability}
                      onChange={(e) =>
                        setForm({ ...form, extra_capability: e.target.value })
                      }
                    />
                  </div>

                  <div className="col-md-4 mb-2">
                    <label className="form-label">Bed Charge</label>
                    <input
                      type="number"
                      className="form-control"
                      value={form.bed_charge}
                      onChange={(e) =>
                        setForm({ ...form, bed_charge: e.target.value })
                      }
                    />
                  </div>

                  <div className="col-md-4 mb-2">
                    <label className="form-label">Room Size</label>
                    <select
                      className="form-select"
                      value={form.room_size}
                      onChange={(e) =>
                        setForm({ ...form, room_size: e.target.value })
                      }
                    >
                      {ROOM_SIZES.map((s) => (
                        <option key={s} value={s}>
                          {s}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-md-4 mb-2">
                    <label className="form-label">Bed Number</label>
                    <input
                      type="number"
                      className="form-control"
                      value={form.bed_number}
                      onChange={(e) =>
                        setForm({ ...form, bed_number: e.target.value })
                      }
                    />
                  </div>

                  <div className="col-md-4 mb-2">
                    <label className="form-label">Bed Type</label>
                    <select
                      className="form-select"
                      value={form.bed_type}
                      onChange={(e) =>
                        setForm({ ...form, bed_type: e.target.value })
                      }
                    >
                      {BED_TYPES.map((b) => (
                        <option key={b} value={b}>
                          {b}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-12 mb-2">
                    <label className="form-label">Description</label>
                    <textarea
                      className="form-control"
                      value={form.room_description}
                      onChange={(e) =>
                        setForm({ ...form, room_description: e.target.value })
                      }
                    />
                  </div>

                  <div className="col-12 mb-2">
                    <label className="form-label">Reserve Condition</label>
                    <input
                      className="form-control"
                      value={form.reserve_condition}
                      onChange={(e) =>
                        setForm({ ...form, reserve_condition: e.target.value })
                      }
                    />
                  </div>

                  {/* <div className="col-md-4 mb-2">
                    <label className="form-label">Status</label>
                    <select
                      className="form-select"
                      value={form.status}
                      onChange={(e) =>
                        setForm({ ...form, status: e.target.value })
                      }
                    >
                      {ROOM_STATUS.map((s) => (
                        <option key={s} value={s}>
                          {s}
                        </option>
                      ))}
                    </select>
                  </div> */}

                  {/* <div className="col-md-4 mb-2">
                    <label className="form-label">Housekeeping</label>
                    <select
                      className="form-select"
                      value={form.housekeeping_status}
                      onChange={(e) =>
                        setForm({
                          ...form,
                          housekeeping_status: e.target.value,
                        })
                      }
                    >
                      {HOUSEKEEPING.map((h) => (
                        <option key={h} value={h}>
                          {h}
                        </option>
                      ))}
                    </select>
                  </div> */}

                  <div className="col-md-4 mb-2 d-flex align-items-center">
                    <div className="form-check me-3">
                      <input
                        id="is_active_edit"
                        className="form-check-input"
                        type="checkbox"
                        checked={form.is_active}
                        onChange={() =>
                          setForm({ ...form, is_active: !form.is_active })
                        }
                      />
                      <label
                        htmlFor="is_active_edit"
                        className="form-check-label"
                      >
                        Active
                      </label>
                    </div>
                    {/* <div className="form-check">
                      <input
                        id="is_maintenance_edit"
                        className="form-check-input"
                        type="checkbox"
                        checked={form.is_maintenance}
                        onChange={() =>
                          setForm({
                            ...form,
                            is_maintenance: !form.is_maintenance,
                          })
                        }
                      />
                      <label
                        htmlFor="is_maintenance_edit"
                        className="form-check-label"
                      >
                        Is Maintenance
                      </label>
                    </div> */}
                  </div>

                  <div className="col-12 mt-2">
                    <label className="form-label">Amenities</label>
                    <div className="d-flex flex-wrap gap-2">
                      {amenities.map((a) => (
                        <div key={a.id} className="form-check me-3">
                          <input
                            id={`amenity_edit_${a.id}`}
                            className="form-check-input"
                            type="checkbox"
                            checked={form.amenity_ids.includes(a.id)}
                            onChange={() => toggleAmenity(a.id)}
                          />
                          <label
                            htmlFor={`amenity_edit_${a.id}`}
                            className="form-check-label"
                          >
                            {a.name}
                          </label>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => {
                    // if (onUpdated) onUpdated();
                    onClose();
                  }}
                >
                  Close
                </button>
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={loading}
                >
                  {loading ? (
                    <span className="spinner-border spinner-border-sm" />
                  ) : (
                    "Update"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditRoom;
